"use client";

import { c as _c } from "react/compiler-runtime";
import React, { useState } from "react";
export const LiveRecorder = t0 => {
  const $ = _c(1);
  const {
    id
  } = t0;
  useState(id);
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <div className="bg-EB5757 w-[75px] h-[20px] rounded-full flex items-center justify-center"><div className="flex items-center justify-center"><svg width="14" height="12" viewBox="0 0 24 24" fill="currentColor" className="text-FFFFFF"><rect x="1.5" y="5" width="13" height="14" rx="2" ry="2" /><path d="M15.5 9.25 L21 6.5 V17.5 L15.5 14.75 V9.25 Z" /></svg></div><span className="text-FFFFFF text-12-tamil-700 uppercase tracking-wide">வாழ்க</span></div>;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  return t1;
};